import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Titulo from '@components/Titulo';
import Resumen from '@components/Resumen';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Boton from '@components/Boton';

import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorStyle } from '@styles/cajaContenedor';
import { cajaContenedorPrimeroStyle } from '@styles/cajaContenedorPrimero';

import { verHorasApi, verHorasJornadaApi, verHorasOcupadasApi } from "@api/wp/agenda/horas/horasApi"
import { colors } from '@styles/colors';
import LoadingOverlay from '@components/LoadingOverlay';
import { useCita } from '@providers/citaContext';

const Horas = () => {
  const [horas, setHoras] = useState([]);
  const [horasOcupadas, setHorasOcupadas] = useState([]);
  const [cargandoHoras, setCargandoHoras] = useState(false);
  const [errorHoras, setErrorHoras] = useState(null);
  const [horaSeleccionada, setHoraSeleccionada] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { cita, setCita } = useCita();

  // Estado para almacenar todos los parámetros recibidos
  const [parametros, setParametros] = useState({
    oid_ciudad: '',
    ciudad_nombre: '',
    oid_modalidad: '',
    fecha_seleccionada: '',
    oid_medico: '',
    oid_servicio: '',
    oid_sede: ''
  });
  const {
    ciudadId,
    ciudadNombre,
    especialidadNombre,
    oidEspecialidad,
    sedeId,
    sedeNombre,
    fecha,
    medicoSeleccionado,
    medicoNombre,
    horarioSeleccionado,
    empresaArray,
    valorPreviplan,
    sku,
    nombreServicio,
    descripcion,
    empresaSeleccionada,
    documento_medico
  } = {
    ciudadId: cita?.ciudadId ?? location.state?.ciudadId,
    ciudadNombre: cita?.ciudadNombre ?? location.state?.ciudadNombre,
    especialidadNombre: cita?.especialidadNombre ?? location.state?.especialidadNombre,
    oidEspecialidad: cita?.oidEspecialidad ?? location.state?.oidEspecialidad,
    sedeId: cita?.sedeId ?? location.state?.sedeId,
    sedeNombre: cita?.sedeNombre ?? location.state?.sedeNombre,
    fecha: cita?.fecha ?? location.state?.fecha,
    medicoSeleccionado: cita?.medicoSeleccionado ?? location.state?.medicoSeleccionado,
    medicoNombre: cita?.medicoNombre ?? location.state?.medicoNombre,
    horarioSeleccionado: cita?.horarioSeleccionado ?? location.state?.horarioSeleccionado,
    empresaArray: cita?.empresaArray ?? location.state?.empresaArray,
    valorPreviplan: cita?.valorPreviplan ?? location.state?.valorPreviplan,
    sku: cita?.sku ?? location.state?.sku,
    nombreServicio: cita?.nombreServicio ?? location.state?.nombreServicio,
    descripcion: (cita?.descripcion ?? location.state?.descripcion) || '',
    empresaSeleccionada: cita?.empresaSeleccionada ?? location.state?.empresaNombre,
    documento_medico: cita?.documento_medico ?? location.state?.documento_medico,
  };

  // Validar que el contexto de cita no esté vacío; si lo está, regresar a Home
  useEffect(() => {
    const citaVacia = !cita || (typeof cita === 'object' && Object.keys(cita).length === 0);
    if (citaVacia) {
      navigate('/home');
      return;
    }
  }, []);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Formatea una hora "HH:MM:SS" a "hh:mm AM/PM"
  const formatHora = (horaStr) => {
    if (!horaStr || typeof horaStr !== 'string') return horaStr;
    const parts = horaStr.split(':');
    const hh = parseInt(parts[0], 10);
    const mm = parts[1] ?? '00';
    if (Number.isNaN(hh)) return horaStr;
    const sufijo = hh >= 12 ? 'PM' : 'AM';
    let hora12 = hh % 12;
    if (hora12 === 0) hora12 = 12;
    const hhStr = String(hora12).padStart(2, '0');
    const mmStr = String(mm).padStart(2, '0');
    return `${hhStr}:${mmStr} ${sufijo}`;
  };

  useEffect(() => {
    // Extraer parámetros del state
    traerHoras()

  }, [cita, location.state]);

  const traerHoras = async () => {
    setCargandoHoras(true);
    setErrorHoras(null);
    setHoras([]);
    setHorasOcupadas([]);

    try {
      const data = {
        empresa: empresaSeleccionada,
        turnomedico: horarioSeleccionado
      }
      console.log(data)
      const response = await verHorasJornadaApi(data);

      // Consultar horas ocupadas locales
      const bookedData = {
        empresa: empresaSeleccionada,
        oid_especialidad: oidEspecialidad,
        oid_medico: medicoSeleccionado,
        fecha: fecha
      };      
      let bookedList = [];
      try {
        console.log('Book ', bookedData) 
        const responseBooked = await verHorasOcupadasApi(bookedData);
        console.log('RESPONSE BOOKED', responseBooked)        
        if (responseBooked && responseBooked.result) {
             bookedList = responseBooked.result.map(item => item.hora);
        }
      } catch (err) {
        console.error('Error fetching booked hours', err);
      }
      setHorasOcupadas(bookedList);

      console.log('ERSPO HOAS', response)
      if (response && response.data) {
        const slots = [];
        const rawData = Array.isArray(response.data) ? response.data : [response.data];

        rawData.forEach(turno => {
          if (!turno.fechaini || !turno.fechafin) return;

          const start = new Date(turno.fechaini);
          const end = new Date(turno.fechafin);
          
          let current = new Date(start);

          while (current < end) {
             const hours = current.getHours().toString().padStart(2, '0');
             const minutes = current.getMinutes().toString().padStart(2, '0');
             const seconds = current.getSeconds().toString().padStart(2, '0');
             
             slots.push({
               hora: `${hours}:${minutes}:${seconds}`,
               turnoOid: turno.turnoOid
             });
             
             current.setMinutes(current.getMinutes() + 15);
          }
        });

        slots.sort((a, b) => {
             const timeA = a.hora.split(':').map(Number);
             const timeB = b.hora.split(':').map(Number);
             return (timeA[0] * 60 + timeA[1]) - (timeB[0] * 60 + timeB[1]);
        });

        setHoras(slots);
      }
    } catch (error) {
      console.error('Error al consultar horas:', error);
      setErrorHoras('Error al cargar las horas');
    } finally {
      setCargandoHoras(false);
    }
  };
  return (
    <div id="cajaPrincipal"
      style={cajaPrincipalStyle}
    >
      {/* Overlay de carga para horas */}
      <LoadingOverlay visible={cargandoHoras} />
      <Titulo titulo="Define la hora" subtitulo="Elige la hora disponible que mejor se ajuste a tu agenda."
        imagen_titulo="hora"
        rutaRetorno="/agenda/medicos"
        stateRetorno={{
          ciudadId: ciudadId,
          ciudadNombre: ciudadNombre,
          especialidadNombre: especialidadNombre,
          oidEspecialidad: oidEspecialidad,
          sedeId: sedeId,
          sedeNombre: sedeNombre,
          empresaNombre: empresaSeleccionada,
          empresaArray: empresaArray,
          fecha,
          nombreServicio,
          descripcion
        }}
      ></Titulo>
      {/* Div central */}
      <div style={{...cajaContenedorStyle, ...(isMobile && { marginLeft: '0', width: '100%', padding: '0 2vh', boxSizing: 'border-box' })}}>
        {/* Primer div */}

        {/* Contenido del primer div */}
        <div style={{...cajaContenedorPrimeroStyle, ...(isMobile && { width: '100%', marginLeft: '0', display: 'flex', flexDirection: 'column', alignItems: 'center' })}}>
          {/* Contenedor de horas */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            width: isMobile ? '100%' : '63vh',
            marginTop: '3vh',
            marginLeft: isMobile ? '0' : '8vh',
            alignContent: 'center',
            justifyContent: 'center',
            alignItems: 'center',

          }}>
            {cargandoHoras ? (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                height: '20vh',
                width: '100%',
                gap: '1vh'
              }}>
                 <span style={{
                    fontSize: '2.2vh',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    color: colors.primaryText,
                    textAlign: 'center'
                  }}>
                  Cargando horas disponibles...
                </span>
                <span style={{
                    fontSize: '1.4vh',
                    fontFamily: 'Inter',
                    color: colors.gray600,
                    textAlign: 'center'
                  }}>
                  Por favor espere un momento
                </span>
              </div>
            ) : errorHoras ? (
              <div style={{ color: colors.errorText }}>{errorHoras}</div>
            ) : horas.length === 0 ? (
              <div style={{
                textAlign: 'center',
                padding: '3vh',
                backgroundColor: colors.warnBg,
                borderRadius: '1vh',
                border: `2px solid ${colors.warnBorder}`,
                color: colors.warnText,
                boxShadow: `0 0.2vh 1vh ${colors.warnShadow}`,
                fontSize: '2vh',
                fontWeight: '600',
                width: '100%',
                maxWidth: '80vh',
                margin: '0 auto'
              }}>
                No existen horarios disponibles para la fecha seleccionada
              </div>
            ) : (
              <div id="cajaHoras" style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 2fr',
                columnGap: '1.5vh',
                rowGap: '1.5vh',
                width: '100%',
                height: '48vh',
                overflowY: 'auto',
                paddingBottom: '2vh'
              }}>
                {horas.map((hora, index) => {
                  const isBooked = horasOcupadas.includes(hora.hora);
                  const isSelected = horaSeleccionada?.hora === hora.hora;
                  return (
                  <div
                    key={index}
                    style={{
                      width: isMobile ? '100%' : '21.4vh',
                      height: '7.2vh',
                      borderRadius: '1.4vh',
                      border: `0.0vh solid ${isSelected ? colors.verdeClaro : colors.gray150}`,
                      backgroundColor: isBooked ? '#e0e0e0' : `${isSelected ? colors.verdeClaro : colors.gray150}`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: isBooked ? 'not-allowed' : 'pointer',
                      opacity: isBooked ? 0.6 : 1,
                      transition: 'all 0.3s ease',
                      fontSize: '1.3vh',
                      fontWeight: '100',
                      color: isBooked ? '#a0a0a0' : `${isSelected ? colors.accent : colors.gray600}`
                    }}
                    onClick={() => {
                      if (!isBooked) setHoraSeleccionada(hora);
                    }}
                  >
                    <span style={{
                      fontSize: '2.6vh',
                      fontWeight: isSelected && !isBooked ? 700 : 400,
                      fontFamily: 'Inter',
                      color: isBooked ? '#a0a0a0' : `${isSelected ? colors.accent : colors.gray600}`
                    }}>
                      {formatHora(hora.hora)}
                    </span>
                    <ChevronRightIcon style={{
                      marginLeft: '0.3vh',
                      fontSize: '3.2vh',
                      transform: 'rotate(0deg)',
                      display: isBooked ? 'none' : 'block'
                    }} />
                  </div>
                )})}
              </div>
            )}
          </div>
          <div id="cajaSiguiente" style={{
            display: 'flex',
            flexDirection: 'column',
            width: isMobile ? '100%' : '80vh',
            marginTop: '1vh',
            gap: '2vh',
            justifyContent: isMobile ? 'center' : 'flex-end',
            alignItems: isMobile ? 'center' : 'flex-end',
            position: 'relative',
          }}>
            <Boton
              label={"Pagar ahora"}
              onClick={() => {
                if (horaSeleccionada?.hora) {
                  setCita(prev => ({
                    ...prev,
                    ciudadId,
                    ciudadNombre,
                    especialidadNombre,
                    nombreServicio,
                    descripcion,
                    oidEspecialidad,
                    sedeId,
                    sedeNombre,
                    fecha,
                    medicoSeleccionado,
                    medicoNombre,
                    horarioSeleccionado,
                    horaSeleccionada: horaSeleccionada.hora,
                    empresaArray,
                    empresaSeleccionada,
                    valorPreviplan,
                    documento_medico,
                    sku
                  }));
                  navigate('/confirmar');
                }
              }}
              siguiente
              ancho={isMobile ? '100%' : '23vh'}
              alto="5.2vh"
              disabled={!horaSeleccionada}
            />
          </div>
        </div>
        {/* Fin contenido del primer div */}

        {!isMobile && <Resumen ciudad={ciudadNombre} servicio={especialidadNombre} ubicacion={sedeNombre} fecha={fecha} medico={medicoNombre} nomServicio={nombreServicio} descripcion={descripcion} />}

      </div>
    </div>
  );
};

export default Horas;